// extracted by mini-css-extract-plugin
module.exports = {"pageLoader":"jut__PageLoader__pageLoader","appLoading":"jut__PageLoader__appLoading"};